// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"560":"ca6a952c","950":"e7f6d398","1793":"70c21f4f","2769":"47d77f35","7713":"e7f6d398","8134":"baa5c7a2","8512":"e7f6d398"}[chunkId] + ".chunk.css";
};